import { useTenant } from '@parcel2go/npm-p2g-app';
import { TenantSettingKeys } from '~/lib/consts/tenant-setting-keys';

/**
 * The single reader of UI-SERVERLESS.PUBLIC.SUBSCRIPTIONS.ENABLED in this app.
 *
 * Tenants that don't sell subscriptions (e.g. white-label) have it off. It gates the My Plan
 * tab/page, the sidebar plan widget, the pending-plan link capture and - via
 * ~/hooks/use-entitlements - the entitlements read itself. Every call site has to agree, or the
 * storefront and the shared chrome disagree about whether a tenant has subscriptions at all.
 *
 * Do not re-read this key anywhere else; import this hook (or `isSubscriptionsEnabled`) instead.
 */
export function isSubscriptionsEnabled(settings: { [key: string]: string }): boolean {
  return settings[TenantSettingKeys.SUBSCRIPTIONS.ENABLED] === 'true';
}

const useSubscriptionsEnabled = () => isSubscriptionsEnabled(useTenant().settings);

export default useSubscriptionsEnabled;
